import { Pencil, Trash2 } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export const ProductsTable = ({ products, onEdit, onDelete }) => (
  <div className="border border-olive/30 bg-cream">
    <Table>
      <TableHeader>
        <TableRow className="border-olive/30 hover:bg-transparent">
          <TableHead className="text-charcoal/70">Product</TableHead>
          <TableHead className="text-charcoal/70">Category</TableHead>
          <TableHead className="text-charcoal/70">Price</TableHead>
          <TableHead className="text-charcoal/70">Featured</TableHead>
          <TableHead className="text-charcoal/70 text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {products.map((p) => (
          <TableRow key={p.id} data-testid={`admin-product-row-${p.id}`} className="border-olive/20">
            <TableCell>
              <div className="flex items-center gap-3">
                <img src={p.image_url} alt="" className="w-12 h-14 object-cover" />
                <span className="font-body text-charcoal">{p.title}</span>
              </div>
            </TableCell>
            <TableCell className="font-body text-charcoal/70">{p.category}</TableCell>
            <TableCell className="font-body text-charcoal/70">{p.price || "—"}</TableCell>
            <TableCell className="font-body text-charcoal/70">{p.featured ? "Yes" : "—"}</TableCell>
            <TableCell className="text-right">
              <div className="flex justify-end gap-2">
                <button data-testid={`edit-product-${p.id}`} onClick={() => onEdit(p)} className="p-2 text-charcoal/60 hover:text-burgundy transition-colors">
                  <Pencil size={16} />
                </button>
                <button data-testid={`delete-product-${p.id}`} onClick={() => onDelete(p)} className="p-2 text-charcoal/60 hover:text-maroon transition-colors">
                  <Trash2 size={16} />
                </button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);
